import { render, staticRenderFns } from "./add-banner-form.vue?vue&type=template&id=643ee5d2&"
import script from "./add-banner-form.vue?vue&type=script&lang=js&"
export * from "./add-banner-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports